/**
 * Run async task factories with a bounded number of in-flight promises.
 * Preserves result order matching `tasks` indices.
 */
export async function runWithConcurrencyLimit<T>(
  tasks: Array<() => Promise<T>>,
  limit: number,
): Promise<T[]> {
  if (tasks.length === 0) {
    return [];
  }
  const safeLimit = Math.max(1, Math.floor(limit));
  const results = new Array<T>(tasks.length);
  let nextIndex = 0;

  async function worker(): Promise<void> {
    while (true) {
      const i = nextIndex++;
      if (i >= tasks.length) return;
      results[i] = await tasks[i]();
    }
  }

  const workerCount = Math.min(safeLimit, tasks.length);

  await Promise.all(Array.from({ length: workerCount }, () => worker()));
  return results;
}
